export interface ShortcutHandlers {
  focusSearch: () => void;
  home: () => void;
  back: () => void;
  forward: () => void;
  zoomIn: () => void;
  zoomOut: () => void;
  reset: () => void;
  toggleFavorite: () => void;
  toggleHelp: () => void;
}

/** Atalhos de teclado globais. Inputs tratam suas próprias teclas. */
export function installShortcuts(h: ShortcutHandlers) {
  window.addEventListener("keydown", (e) => {
    const el = e.target as HTMLElement | null;
    const typing = !!el && (/^(INPUT|TEXTAREA)$/.test(el.tagName) || el.isContentEditable);
    if (typing) return; // o input cuida de Esc/Enter/setas

    switch (true) {
      case e.key === "/" || ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k"):
        e.preventDefault(); h.focusSearch(); break;
      case e.key === "Escape": h.reset(); break;
      case e.altKey && e.key === "ArrowLeft": e.preventDefault(); h.back(); break;
      case e.altKey && e.key === "ArrowRight": e.preventDefault(); h.forward(); break;
      case e.key === "Home" || e.key === "0": h.home(); break;
      case e.key === "+" || e.key === "=": h.zoomIn(); break;
      case e.key === "-" || e.key === "_": h.zoomOut(); break;
      case e.key.toLowerCase() === "f": h.toggleFavorite(); break;
      case e.key === "?": h.toggleHelp(); break;
    }
  });
}
